// removed by extract-text-webpack-plugin
module.exports = {"root":"spinner--root--d2nNm8Xz","spinner":"spinner--spinner--2sCv1rlF"};


//////////////////
// WEBPACK FOOTER
// ./components/spinner/styles.css
// module id = ./components/spinner/styles.css
// module chunks = 0